<template>
  <div>
    <transition name="fadeModal">
      <div v-if="modalActive" class="contact-modal">
        <div class="container--lg gutter--xs">
          <!-- Header -->
          <div class="modal__header test">
            <svg
              class="modal__header__logo"
              viewBox="0 0 45 40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27 0v6h-4.755v3H25v2.687h3V6h6v6h-6v28H16.492V11.687H0V0h27zm12 6v3h-3V6h3zm6-6v6h-6V0h6zM34 0v3h-3V0h3z"
                fill="#FFF"
                fill-rule="evenodd"
              ></path>
            </svg>

            <button @click="hideModal" class="modal__header__closeBtn">
              Close
              <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <g
                  stroke="#FFF"
                  stroke-width="1.5"
                  fill="none"
                  fill-rule="evenodd"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M1.25 38.748l37.5-37.5M38.75 38.748l-37.5-37.5"
                  ></path>
                </g>
              </svg>
            </button>
          </div>

          <div class="modal__container">
            <div class="modal__inner">
              <div>
                <h5>Headquarters</h5>
                <div aria-label="TCNA Contact Info" class="vcard | mb-12">
                  <a
                    v-if="address.mapUrl"
                    :href="address.mapUrl"
                    target="_blank"
                    class="vcard__item | addr"
                  >
                    <span class="block street-address"
                      >{{ address.address1 }} {{ address.address2 }}</span
                    >
                    <span class="locality">{{ address.locality }}</span>
                    <span class="region">{{ address.administrativeArea }}</span>
                    <span class="postal code">{{ address.postalCode }}</span>
                  </a>
                  <div v-else class="vcard__item | addr">
                    <span class="block street-address"
                      >{{ address.address1 }} {{ address.address2 }}</span
                    >
                    <span class="locality">{{ address.locality }}</span>
                    <span class="region">{{ address.administrativeArea }}</span>
                    <span class="postal code">{{ address.postalCode }}</span>
                  </div>
                </div>
                <div v-if="partnerPdf && partnerPdf.url" class="mt-8">
                  <h5>Want to Become a TCNA Vendor Partner?</h5>
                  <a :href="partnerPdf.url" download="Information Packet"
                    >Click here for more information</a
                  >
                </div>
              </div>
              <div>
                <h5>Follow Us</h5>
                <ul class="menu-list">
                  <li v-for="item in sociallinks" class="menu-list__item">
                    <a
                      :href="item.accountUrl"
                      target="_blank"
                      rel="noopener"
                      role="accountUrl"
                      aria-haspopup="false"
                      class="menu-list__link"
                      tabindex="0"
                      >{{ item.label }}</a
                    >
                  </li>
                </ul>
              </div>

              <div>
                <h5>Media Inquiries</h5>
                <a :href="'mailto:' + email">{{ email }}</a>
              </div>
            </div>

            <div class="modal__action">
              <a
                :href="primarycta.url"
                class="js-mouse-nearby | btn -gradient mx-auto"
              >
                <span>{{ primarycta.text }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";

export default {
  props: {
    // Classes and btn settings
    triggerClass: {
      type: String,
      required: false,
    },
    email: {
      required: true,
    },
    primarycta: {
      required: true,
    },
    address: {
      required: true,
    },
    partnerPdf: {},
    sociallinks: {
      required: true,
    },
  },
  data() {
    return {
      modalActive: false,
      bodyEl: null,
      scrollableEl: null,
    };
  },

  methods: {
    hideModal() {
      this.modalActive = false;
      enableBodyScroll(this.scrollableEl);
      this.bodyEl.classList.remove("modal-active");
    },
    showModal() {
      this.modalActive = true;
      disableBodyScroll(this.scrollableEl);
      this.bodyEl.classList.add("modal-active");
    },
  },

  mounted() {
    //Set
    this.bodyEl = document.querySelector("body");
    this.scrollableEl = this.$el.querySelector(".contact-modal");

    // Handle Modal Toggle
    this.$root.$on("openModal", (status) => {
      if (status) {
        this.showModal();
      } else {
        this.hideModal();
      }
    });

    // Handle escape key press
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 27) {
        this.hideModal(e);
      }
    });
  },
};
</script>

<style>
.fadeModal-enter-active,
.fadeModal-leave-active {
  transition: opacity ease-in-out 0.15s;
}
.fadeModal-enter,
.fadeModal-leave-to {
  opacity: 0.01;
}
</style>
